import React, { useState, useEffect, useCallback, Fragment } from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import { Container, Row, Col, Card, ListGroup, Table, Form, FormControl, Button, Modal, OverlayTrigger, PopoverTitle, PopoverContent } from 'react-bootstrap'
import { makeStyles } from '@material-ui/styles'
import {getTDAccountsAPI, getNewTokenWithRefresh, setTDSettingsAPI, resetTDSettingsAPI} from '../../api/trading/td'
import { handleErrors } from '../../api/base'
import {Toasty} from '../../components/trading/toast'
import { setTokenAction, tdClearDataAction } from '../../actions/td'
import {formatNegative} from '../../utility/numberFormat'
import { Discord } from '../discord/discord'
import { ChangePassword } from './changepw'
import { ChangeLog } from './changelog'

const useStyles = makeStyles({
    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    column: {
        flexDirection: 'column'
    },
    fullHeight: {
        height: '100vh'
    },
    big: {
        height: '40%',
        width: '80%'
    },
    outline: {
        border: '.2rem solid #ececec',
        borderRadius: '8px'
    },
    darkJumbo: {
        backgroundColor: '#d2d5d8'
    },
    padded: {
        padding: '15px'
    },
    noPad: {
        padding: '0px'
    }
})
export const UserSettings = () => {
    
    const user = useSelector(state => state.user)
    const tdState = useSelector(state => state.td)
    const classes = useStyles()
    const dispatch = useDispatch()

    const [accounts, setAccounts] = useState([])
    const [toasts, setToasts] = useState([])

    const [showModal, setShowModal] = useState(false)
    const [showRefreshModal, setShowRefreshModal] = useState(false)

    const linkTDClick = () => {
        setShowRefreshModal(true)
        window.open('https://auth.tdameritrade.com/auth?response_type=code&redirect_uri=https%3a%2f%2fvarbis.net%2ftdsync&client_id=27CVWVLRIVWLAAMWEJRNLJLH4CSSQG9V%40AMER.OAUTHAP')
        //window.open('https://auth.tdameritrade.com/auth?response_type=code&redirect_uri=https%3a%2f%2flocalhost%3a3000%2ftdsync&client_id=27CVWVLRIVWLAAMWEJRNLJLH4CSSQG9V%40AMER.OAUTHAP')
    }

    const selectTDAccount = () => {
        return getTDAccountsAPI(user.UserID, user.IdToken, user.AccessToken, tdState.token.access_token)
            .then(handleErrors)
            .then(results => {
                if (results === null){
                    return
                }
                console.log(results)
                setAccounts(results)
                setShowModal(true)
            })
            .catch(error => error)
            .then(msg => {
                if (msg){
                    notify('Error', msg)
                }
            })
    }

    const refreshTDToken = () => {
        if (!tdState.token.refresh_token){
            notify('Error', 'No Refresh Token, please Link TD Account')
            return;
        }
        return getNewTokenWithRefresh(user.UserID, user.IdToken, user.AccessToken, tdState.token.refresh_token)
                .then(handleErrors)
                .then(result => {
                    if (!result || !result.access_token){
                        notify('Token Error', 'Error While Refreshing Token')
                        return
                    }
                    dispatch(setTokenAction(result))
                })
                .catch(error => error)
                .then(msg => {     
                    if (msg){
                        console.log(msg)
                        notify('Error', msg.toString())
                    }
                })
    }

    const unlinkTDAccount = () => {
        return resetTDSettingsAPI(user.UserID, user.IdToken, user.AccessToken)
            .then(handleErrors)
            .then((results) => {
                console.log(results)
                dispatch(tdClearDataAction())
            })
            .catch(error => error)
            .then(msg => {
                if (msg){
                    notify('Error', 'Error Unlinking TD Account')
                }
            }) 
    }

    const pickTDAccount = (accountID) => {
        setShowModal(false)
        return setTDSettingsAPI(user.UserID, user.IdToken, user.AccessToken, accountID)
            .then(handleErrors)
            .then(results => {
                notify('Linked', `Account ${accountID} Has Been Linked!`)
            })
            .catch(error => error)
            .then(msg => {
                if (msg){
                    notify('Error', msg.toString())
                }
            })
    }

    // useEffect(() => {
    //     dispatch(setTokenAction({"access_token":"YhIQ4HDo/Zf8VaH42HpgSUq0pdx8Rmd195A/2XlvsMQOUS5AwSYRlL+N4y8qtwne981oIll3B131HQ16m2haN4RFL2kmFJFoDkdp9tylOL31J4jCLJuTHaU0Knek0/Hmn0nL2k6SdT3dsXaBAqP4/6wSb8CLpzqMo5pHv+KTbDWaxstLR/TeaLj7JLRgD5bL+SFVyWvsv50nA+WsC9aGY0jAxev2b+l5Rx5tvyz1mhPK8ZUTxYQpgWJppIME7vWYwJAa3Aj5OAMwrTTgmM8Z1hZ5duKYnGSGsVfqIgixkFt34u30xcYwfgPFG+ZnnVczFL4+1Fwzpyv6fT+Hf5uaTqVfQpWbPDGb5vObtY/Ys8oMzcYOG4rub12B6VSzPaylpspHfRPFAnOKezYf54YdwvIiKxfACh9uWtXvkFEIF6jeEvD+Mfxl1eHW9ZK7yEn9ImxnUsrYMboEIq6SFXZ1VOsTJk6mRCmV+SjDG4LjkxarbEhPo/6VvErcJwZq9ELDlJBzeeJARssz49hOEn17b+v6BgLduh3EYSRy3Ugd9vWksRdV1100MQuG4LYrgoVi/JHHvl21AaZpRB1hv5qMomW9Ewf04w9xuNCGWItGnbJ3PRWXHprBPp6/nwD3t1w0yvVW036vcQymIhJSOgPkLC4DByosRl08wPeNHA4zon3v6hIntIXtBRtWIKadW9Kgi3DoOxEKdwo0dCdexvU2bfxHcnKUOSScXbpLuSH3uLPE7lev9xuarDENSBLb5tGTa6N2TFw5AU8wbINSkAKEHzSCkOMxUU6wVWse0miSWN8aZbay4DVQWT4GVwnz9CxYxmW/wsNHiTEH3C2U8CteR5SRkGUb5uOL5qrkBn3usXruny4rURILrWw1ksNgbakZwUsJNi4hqx1rRBguIDo7iEd5oExsBD/8T/mzCR17EQnjtNayLBuvedjfYSN8Xo5FIKm/egVgfh3leG6p2k0ClbCcMWy82iogy01HSwRvv3cePh9XGVcxpiLlW/Q0yQCsowwgmbqWhsN35eMlWDIEE/EVPuh/dJDHWLjmoOg/LwSUaB2dt2Ri1DqYVoBzLx6l3Of3wWj3rdXZHVRzMHWx0lQVflXe5adXt+LTKFTf6QUNWsS1ly13+g==212FD3x19z9sWBHDJACbC00B75E","refresh_token":"VVLs/SDQCpCfvjqSFXBMgEEGOjrV7Pai0CXZ3Zy7Ka00yk3vAUmKAm8oXRIs61O6Admc72JhlhoH01RdU8K9H1FyvG9Zyri9KTuAJjtIHBovnC6nwbKvZNVf8iXB+JxSRxXzK5jlVZQckVlgRokqeURc7NQ6F0JDBkm/2Gb0vA2d09BeesNpSIJjp3/upZwXn8Qk8pUV2t5wiyCaCJFmHUA+9bz6oMu215boLe0jMSYAyMtCbaXcT9rQGhy4dshLRJ7XNyoR/dzBucXZ7WSNKEMP///DBmdkS1Akesu7upg8Gz8DWBtdHufAKehLN8KRwimRqWDcx8vBIyVcgmcZY2TbJlkajjE+IhS+LI0yPEQGUDJenb5a2Lvy/NNYDivnKdhae5NS8Sw/ifNzOG7Cweih951vMfCVp56/AY6ATCOoO9ClQTamkKD5IfM100MQuG4LYrgoVi/JHHvltiL74k01XFQAyaj+p7a8DAmfzylNc8BWEUD9mHi4PXfOThbWTk5tJrhi6uAIcSYPr7vSe0pOXLGouKqfJEKs0SkWjkQx6k41rF4SMNZ1MmJkwZhTWbVIaUledhEN/f0Umm/7GGR+wiuuDxRXtqowZqZS0AKX+eJ+9hQkXmXoR0xjULGLrGWGbNtOPLj4gvsf8b39RdTJTnDmUapNbwd0bhTj2qd5DHQWAffmxPsTVb2Xtv+nPtnmbtHJb6u8AGHZ0gIRtCUkckUQ0J+CP24CostN2iknnwXoTjhyY6rvmict0s9b69y7s4YBG4OcCSFIgkPgdhfBQyXbZbFr5HayDPWt06RaT2YXfvqBJw+FEggE3qnodRU0L2saM+ljWNpmSp8kJcnbko5ViEmKNiFhmXNTTTIwAZix1Qx1h4N5jJfWKXEqy7OuK40AmNc=212FD3x19z9sWBHDJACbC00B75E","token_type":"Bearer","expires_in":1800,"scope":"PlaceTrades AccountAccess MoveMoney","refresh_token_expires_in":7776000}))
    // },[])

    
    const notify = (title, msg) => {
        let tsts = toasts.map(x => x)
        tsts.push({
            Title: title,
            Message: msg
        })
        setToasts(tsts)
    }

    return (
        <Container fluid>
            <Row>
                <Col sm={12} lg={6}>
                    {(user.Flags & 8) === 8 && (
                        <Row>
                            <Col sm={12} style={{padding: '15px'}}>
                                <Card bg="dark">
                                    <Card.Header style={{color: 'white', display: 'flex', justifyContent: 'center'}}><b>TD Ameritrade [BETA]</b></Card.Header>
                                    <Card.Body>
                                        <div style={{color: 'white'}}>An account must be created first, then linked. From there you will need to select a specific trading account you wish to use.</div>
                                        <br />
                                        <div style={{display: 'flex', justifyContent: 'space-evenly'}}>
                                        <Button onClick={linkTDClick} variant="secondary">Link TD Account</Button>
                                        {tdState.token && tdState.token.access_token && (
                                            <Fragment>
                                                <Button onClick={selectTDAccount} variant="secondary">Select TD Account</Button>
                                                <Button onClick={refreshTDToken} variant="secondary">Refresh Token</Button>
                                                <Button onClick={unlinkTDAccount} variant="secondary">Unlink TD Account</Button>
                                            </Fragment>
                                        )}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col sm={12} style={{padding: '15px'}}>
                            <Discord notify={notify} />
                        </Col>
                    </Row>
                    <Row>                
                        <Col sm={12} style={{padding: '15px'}}>
                            <ChangePassword notify={notify} />
                        </Col>
                    </Row>
                    {/* <Col sm={12} lg={6} style={{padding: '15px'}}>
                        <Card bg="dark">
                            <Card.Header style={{color: 'white', display: 'flex', justifyContent: 'center'}}><b>Ally</b></Card.Header>
                            <Card.Body>
                                <div style={{color: 'white'}}>An account must be created first, then linked. From there you will need to select a specific trading account you wish to use.</div>
                                <br />
                                <div style={{display: 'flex', justifyContent: 'space-evenly'}}>
                                <Button onClick={linkTDClick} variant="secondary">Link Ally Account</Button>
                                {tdState.token && tdState.token.access_token && <Button onClick={selectTDAccount} variant="secondary">Select Ally Account</Button>}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col> */}
                </Col>
                {/* <Row>
                    <Col sm={12} lg={6} style={{padding: '15px'}}>
                        <Card bg="dark">
                            <Card.Header style={{color: 'white', display: 'flex', justifyContent: 'center'}}><b>Robinhood</b></Card.Header>
                            <Card.Body>
                                <div style={{color: 'white'}}>An account must be created first, then linked. From there you will need to select a specific trading account you wish to use.</div>
                                <br />
                                <div style={{display: 'flex', justifyContent: 'space-evenly'}}>
                                <Button onClick={linkTDClick} variant="secondary">Link TD Account</Button>
                                {tdState.token && tdState.token.access_token && <Button onClick={selectTDAccount} variant="secondary">Select WeBull Account</Button>}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col sm={12} lg={6} style={{padding: '15px'}}>
                    <Card bg="dark">
                            <Card.Header style={{color: 'white', display: 'flex', justifyContent: 'center'}}><b>WeBull</b></Card.Header>
                            <Card.Body>
                                <div style={{color: 'white'}}>An account must be created first, then linked. From there you will need to select a specific trading account you wish to use.</div>
                                <br />
                                <div style={{display: 'flex', justifyContent: 'space-evenly'}}>
                                <Button onClick={linkTDClick} variant="secondary">Link WeBull Account</Button>
                                {tdState.token && tdState.token.access_token && <Button onClick={selectTDAccount} variant="secondary">Select WeBull Account</Button>}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>       */}
                <Col sm={12} lg={6}>
                    <Row>
                        <Col sm={12} style={{padding: '15px'}}>
                            <ChangeLog />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <div style={{position: 'fixed', top: '20px', right: '20px'}}>
                {toasts.map(x => {
                    return <Toasty title={x.Title} message={x.Message} />
                })}
            </div>
            <Modal show={showModal} onHide={() => {setShowModal(false)}}>
                <Modal.Header closeButton>
                    <Modal.Title>Possible Accounts</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>Click the Account you wish to link</div>
                    <ListGroup>
                        {accounts.map(x => {return (
                            <ListGroup.Item style={{display: 'flex', justifyContent: 'space-between'}} onClick={() => {pickTDAccount(x.AccountID)}}><span>Account : {x.AccountID}</span><span>Value : ${formatNegative(x.Value)}</span></ListGroup.Item>
                        )})}
                    </ListGroup>
                </Modal.Body>
            </Modal>
            <Modal show={showRefreshModal} onHide={() => {setShowRefreshModal(false)}}>
                <Modal.Header closeButton>
                    <Modal.Title>Linking</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>Click the button below once you have completed the link</div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => {setShowRefreshModal(false); window.location.reload()}}>
                        Complete Link
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    )
}

export default UserSettings
